import { Directive, HostListener, input } from "@angular/core";

@Directive({
  selector: "[blockedChars]",
})
export class BlockedCharsDirective {
  blockedChars = input.required<string[]>();

  @HostListener("keydown", ["$event"]) public onKeyDown(event: KeyboardEvent) {
    if (!this.blockedChars().includes(event.key)) return;
    event.preventDefault();
  }

  @HostListener("input", ["$event"]) public onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const filteredValue = this._filter(input.value);
    if (filteredValue === input.value) return;

    const caretPosition = (input.selectionStart ?? input.value.length) - (input.value.length - filteredValue.length);
    input.value = filteredValue;
    input.setSelectionRange(caretPosition, caretPosition);
  }

  private _filter(value: string) {
    return value
      .split("")
      .filter((char) => !this.blockedChars().includes(char))
      .join("");
  }
}
